import { useMcpTool } from 'webmcp-react'
import { computeOnboardingStatus } from 'entities/WebMcp/lib/onboardingStatus'
import { serializeOnboardingStatus } from 'entities/WebMcp/lib/serializers'
import { getOnboardingStatusSchema } from 'entities/WebMcp/model/schemas'
import {
  ONBOARDING_TOOL_DESCRIPTION,
  STATUS_GUIDANCE,
} from 'entities/WebMcp/model/onboardingToolText'
import { okResult, errorResult } from 'entities/WebMcp/lib/toolResult'

/**
 * Registers the read-only get_onboarding_status tool (global). Renders nothing.
 * Reports each of the seven checklist steps as complete / incomplete / unknown,
 * computed from existing front-end signals. `unknown` means there is no reliable
 * in-app signal (webinar, advanced features) — the agent should ask the user
 * rather than assume. remainingCount is the confirmed-incomplete count.
 *
 * The description and the returned guidance live in model/onboardingToolText.
 */
export const OnboardingTools = () => {
  useMcpTool({
    name: 'get_onboarding_status',
    description: ONBOARDING_TOOL_DESCRIPTION,
    input: getOnboardingStatusSchema,
    annotations: { readOnlyHint: true },
    handler: async () => {
      try {
        return okResult(serializeOnboardingStatus(await computeOnboardingStatus()), STATUS_GUIDANCE)
      } catch (e) {
        return errorResult(e)
      }
    },
  })

  return null
}
